module.exports = __webpack_public_path__ + "static/logos-a081cded59ab9096a3c42263cc1dce8e.png";